<ion-header
  [ngClass]="
    platformType !== platformEnum.desktop
      ? platformType === platformEnum?.tablet
        ? 'ion-no-border ion-header-modal-tablet'
        : 'ion-no-border ion-header-modal-mobile'
      : 'ion-no-border ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        data-cy="close-order-product-options-modal-button"
        (click)="dismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="select-order-number-label">
      {{ 'i18n.supportCenter.request.support' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platformType !== platformEnum.desktop
      ? platformType === platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div class="body-content">
    <ion-grid>
      <ion-row class="two-inputs">
        <ion-col [size]="platformType === platformEnum.mobile ? 12 : 5.75">
          <app-selectable-item
            [label]="'i18n.supportCenter.requestModal.requestReason'"
            [value]="selectedReason?.displayText"
            [placeholder]="'i18n.supportCenter.requestModal.pleaseChooseReason'"
            [detailIcon]="'chevron-down-outline'"
            [mediumFont]="true"
            (clickValueEmitter)="openSelectFormatDropdown($event)"
          ></app-selectable-item>
        </ion-col>
        <ion-col [size]="platformType === platformEnum.mobile ? 12 : 5.75">
          <div class="label">
            <span
              >{{ 'i18n.supportCenter.requestModal.email' | translate }}
            </span>
            <span class="required-indicator">
              {{ 'i18n.common.requiredInputIndicator' | translate }}
            </span>
            <ion-icon
              *ngIf="showEmailTooltip"
              id="hover-email-trigger"
              data-cy="email-information-icon"
              name="information-circle-outline"
              class="info-icon"
            ></ion-icon>
            <ion-popover
              data-cy="email-information-popover"
              class="email-info-popover"
              mode="ios"
              side="top"
              trigger="hover-email-trigger"
              dismissOnSelect="true"
              (didPresent)="shouldClosePopoverWithDelay($event)"
              (didDismiss)="removeWindowListener()"
            >
              <ng-template>
                <app-email-info-popover
                  mode="ios"
                  [platformType]="
                    platformType === platformEnum?.desktop ? 'desktop' : 'touch'
                  "
                ></app-email-info-popover>
              </ng-template>
            </ion-popover>
          </div>
          <ion-item class="input-item">
            <ion-input
              aria-labelledby="user-email"
              id="email-input"
              [placeholder]="'i18n.common.emailPlaceholder' | translate"
              data-cy="email-input"
              maxlength="60"
              [(ngModel)]="email"
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <div class="label">
          <span>
            {{ 'i18n.common.comments' | translate }}
          </span>
          <span class="required-indicator">
            {{ 'i18n.common.requiredInputIndicator' | translate }}
          </span>
        </div>
        <ion-textarea
          maxlength="32000"
          fill="outline"
          mode="md"
          [placeholder]="
            'i18n.supportCenter.requestModal.commentsPlaceholder' | translate
          "
          [(ngModel)]="comments"
        >
        </ion-textarea>
      </ion-row>
      <ion-row class="two-inputs">
        <ion-col [size]="platformType === platformEnum.mobile ? 12 : 5.75">
          <ng-container [ngTemplateOutlet]="photos"></ng-container>
        </ion-col>
        <ion-col [size]="platformType === platformEnum.mobile ? 12 : 5.75">
          <div class="label">
            <span>{{ 'i18n.requestCredit.uploadAFile' | translate }}</span>
            <ion-icon
              id="hover-file-trigger"
              data-cy="file-information-icon"
              name="information-circle-outline"
              class="info-icon"
            ></ion-icon>
            <ion-popover
              data-cy="file-information-popover"
              class="accepted-file-types-popover"
              mode="ios"
              trigger="hover-file-trigger"
              trigger-action="hover"
              (didPresent)="closePopoverOnBlur()"
              (didDismiss)="removeWindowListener()"
            >
              <ng-template>
                <app-accepted-file-types-popover
                  [fileTypesList]="acceptedFileTypes"
                ></app-accepted-file-types-popover>
              </ng-template>
            </ion-popover>
          </div>
          <app-file-picker
            [error]="displayPageError"
            [showDefaultErrorMessage]="false"
            [platform]="platformType"
            data-cy="support-request-file-picker"
            [file]="file"
            [showChangeButton]="true"
            (fileAddEvent)="handleFileAddRequest()"
            (fileDeleteEvent)="handleFileDeleteRequest()"
            (processFileEvent)="processFile($event)"
          ></app-file-picker>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platformType !== platformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-cost-report-modal-button"
        [ngClass]="
          platformType !== platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="cost-report-modal-button"
        [ngClass]="
          platformType !== platformEnum.mobile
            ? !!selectedReason && !!email && !!comments
              ? 'usf-fill-green-dsktp-tblt-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : !!selectedReason && !!email && !!comments
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-disabled-mobile-modal-button'
        "
        (click)="submitSupportRequest()"
      >
        {{ 'i18n.common.submit' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<!-- ADD PHOTOS TEMPLATE -->
<ng-template #photos>
  <ion-card-title data-cy="photos-label" class="label">
    {{ 'i18n.requestCredit.addAPhoto' | translate }}
    <ion-icon
      id="hover-photos-trigger"
      data-cy="photos-information-icon"
      name="information-circle-outline"
      class="info-icon"
    ></ion-icon>
    <ion-popover
      data-cy="photos-information-popover"
      class="accepted-file-types-popover"
      mode="ios"
      trigger="hover-photos-trigger"
      trigger-action="hover"
      (didPresent)="closePopoverOnBlur()"
    >
      <ng-template>
        <app-accepted-file-types-popover
          [fileTypesList]="acceptedPhotoTypes"
        ></app-accepted-file-types-popover>
      </ng-template>
    </ion-popover>
  </ion-card-title>
  <div class="photo-card">
    <div
      data-cy="photo-card-1"
      class="empty-image-box"
      [class.add-image-box]="!photoArray?.[0]"
    >
      <div
        *ngIf="!photoArray?.[0]"
        data-cy="add-photo-button"
        class="add-image"
        (click)="handlePhotoAddRequest()"
      >
        <img src="../../assets/icon/camera.svg" />
        <p data-cy="add-photo-text" class="add-photo-text">
          {{ 'i18n.common.add' | translate }}
        </p>
      </div>
      <ion-thumbnail *ngIf="photoArray?.[0]" slot="start">
        <ion-img [src]="photoArray[0]?.webviewPath"></ion-img>
        <div
          data-cy="delete-photo-button"
          class="delete-banner"
          (click)="handlePhotoDeleteRequest(photoArray?.[0])"
        >
          {{ 'i18n.common.delete' | translate }}
        </div>
      </ion-thumbnail>
    </div>

    <div
      data-cy="photo-card-2"
      class="empty-image-box"
      [class.add-image-box]="!photoArray?.[1] && photoArray?.[0]"
    >
      <div
        *ngIf="!photoArray?.[1] && photoArray?.[0]"
        data-cy="add-photo-button"
        class="add-image"
        (click)="handlePhotoAddRequest()"
      >
        <img src="../../assets/icon/camera.svg" />
        <p data-cy="add-photo-text">{{ 'i18n.common.add' | translate }}</p>
      </div>
      <ion-thumbnail *ngIf="photoArray?.[1]" slot="start">
        <ion-img [src]="photoArray[1]?.webviewPath"></ion-img>
        <div
          data-cy="delete-photo-button"
          (click)="handlePhotoDeleteRequest(photoArray?.[1])"
          class="delete-banner"
        >
          {{ 'i18n.common.delete' | translate }}
        </div>
      </ion-thumbnail>
    </div>

    <div
      data-cy="photo-card-3"
      class="empty-image-box"
      [class.add-image-box]="
        !photoArray?.[2] && photoArray?.[0] && photoArray?.[1]
      "
    >
      <div
        *ngIf="!photoArray?.[2] && photoArray?.[0] && photoArray?.[1]"
        data-cy="add-photo-button"
        class="add-image"
        (click)="handlePhotoAddRequest()"
      >
        <img src="../../assets/icon/camera.svg" />
        <p data-cy="add-photo-text">{{ 'i18n.common.add' | translate }}</p>
      </div>
      <ion-thumbnail *ngIf="photoArray?.[2]" slot="start">
        <ion-img [src]="photoArray[2]?.webviewPath"></ion-img>
        <div
          data-cy="delete-photo-button"
          (click)="handlePhotoDeleteRequest(photoArray?.[2])"
          class="delete-banner"
        >
          {{ 'i18n.common.delete' | translate }}
        </div>
      </ion-thumbnail>
    </div>
  </div>
</ng-template>
